import * as types from '../mutation-types';
import { 
    get_restaurants,
    shortcut_template
 } from '@/api/restaurant';



export const state = {
    restaurants: [],
    restaurant: {},
    loading: false,
    shortcut: {},
    currencies: []
}
export const getters = {
    loading: state => state.loading,
    restaurants: state => state.restaurants,
    restaurant: state => state.restaurant,
    shortcut: state => state.shortcut,
    currencies: state => state.currencies,
}
export const mutations = {

    [types.RESTAURANTS](state, payload) {
        state.loading = true;
    },
    [types.RESTAURANTS_FAIL](state, payload) {
        state.loading = false;
        state.restaurants = [];
    },
    [types.RESTAURANTS_SUCCESS](state, payload) {
        state.loading = false;
        state.restaurants = payload;
    },
    [types.SELECT_RESTAURANT](state, payload) {
        state.restaurant = payload;
    },
    [types.CURRENCY_SUCCESS](state, payload) {
        state.currencies = payload;
    },
    getShortcut(state, payload){
       state.shortcut = {}
    },
    getShortcutDone(state, payload){
        state.shortcut = payload.data
    },
    getShortcutFail(state, payload){
        state.shortcut = {}
    }

}
export const actions = {
    async get_restaurant({ commit }, payload) {
        commit(types.RESTAURANTS);
        try {
            const response = await get_restaurants(payload);
            commit(types.RESTAURANTS_SUCCESS, response.data);
        } catch (error) {
            console.log(error)
            commit(types.RESTAURANTS_FAIL);
        }
    },
    select_restaurant({ commit }, payload) {
        console.log(payload, '2');
        commit(types.SELECT_RESTAURANT, payload);
    },
    async getShortcut({ commit }, payload){
        commit('getShortcut');
        try {
            const data = await shortcut_template(payload);
            commit("getShortcutDone", data.data);
        } catch (error) {
            let error_ = error.response;
            commit('getShortcutFail', error_);
        }
    },
    get_currencies({ commit }, payload) {
        commit(types.CURRENCY_SUCCESS, payload);
    }

}
